import { Link } from 'react-router-dom';
import type { comics as ComicsType } from '@/mocks/comics';

type Comic = (typeof ComicsType)[number];

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const isSmall = size === 'small';
  const isLarge = size === 'large';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div
        className={`relative overflow-hidden rounded-lg mb-3 ${
          isSmall ? 'aspect-[3/4]' : isLarge ? 'aspect-[3/4]' : 'aspect-[3/4]'
        }`}
      >
        <img
          src={comic.cover}
          alt={`${comic.title} - 汗汗漫画韩漫作品`}
          title={`${comic.title} - 汗汗漫画韩漫推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {comic.status === 'completed' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded">
            已完结
          </span>
        )}
        {comic.status === 'ongoing' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded">
            连载中
          </span>
        )}

        <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-foreground-950/75 text-background-50 text-xs px-1.5 py-0.5 rounded">
          <i className="ri-star-fill text-accent-400 text-[10px]"></i>
          <span>{comic.rating}</span>
        </div>
      </div>

      <h3 className="font-semibold text-sm text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
        {comic.title}
      </h3>

      {!isSmall && (
        <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
          {comic.description}
        </p>
      )}

      <div className="flex items-center gap-2 mt-2">
        <span className="text-xs text-foreground-400">{comic.author}</span>
        <span className="text-foreground-300">·</span>
        <span className="text-xs text-foreground-400 flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {comic.views > 10000
            ? `${(comic.views / 10000).toFixed(1)}万`
            : comic.views.toLocaleString()}
        </span>
      </div>
    </Link>
  );
}